document.addEventListener('alpine:init', () => {
  Alpine.data('GridProductColors', () => ({
    $gridItem: null,
    mounted() {
      let am = this;
      am.$gridItem = am.$el.closest('.grid-product');
    },
    e_UpdateImage(e) {
      // console.log(e);
      e.preventDefault();
      e.stopImmediatePropagation();
      let am = this;
      let is_mobile = window.matchMedia('(max-width:749px)').matches;

      if (is_mobile && e.type == 'mouseenter') return;
      if (!is_mobile && e.type == 'click') {
        window.location.href = e.target.dataset.href;
      }

      am.$gridItem.querySelectorAll('.grid-product__link').forEach(($item) => {
        $item.setAttribute('href', e.target.dataset.href);
      });

      // console.log(e);
      let $primary_img = am.$gridItem.querySelector('.grid-product__content img:first-child');
      if ($primary_img) {
        $primary_img.removeAttribute('srcset');
        $primary_img.removeAttribute('loading');
        $primary_img.src = e.target.dataset.color_image;
      }

      // let $secondary_img = am.$gridItem.querySelector('.grid-product__secondary-image img:first-child');
      // if ($secondary_img) {
      //   $secondary_img.removeAttribute('srcset');
      //   $secondary_img.removeAttribute('loading');
      //   $secondary_img.src = e.target.dataset.color_image;
      // }
      AOS.refresh();
    }
  }));
});